export const ICON_SHARED_PROPS = {
    width: '48px',
    height: '48px',
    viewBox: '0 0 48 48'
};
